import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { useEffect } from 'react';
import { useController } from 'react-hook-form';

interface IToggleButtons {
  registerName: string;
  option1: { id: number | boolean; value: string };
  option2: { id: number | boolean; value: string };
  defaultValue?: number | boolean;
}

export const ToggleButtons = ({
  registerName,
  option1,
  option2,
  defaultValue,
}: IToggleButtons) => {
  const isDesktop = useIsDesktop();

  const { field } = useController({
    name: registerName,
    defaultValue: defaultValue || option1.id,
  });

  let { ref, value, onChange, ...other } = field;

  useEffect(() => {
    onChange(defaultValue === option1.id ? option1.id : option2.id);
  }, [defaultValue, onChange, option1.id, option2.id]);

  return (
    <ToggleButtonGroup
      ref={ref}
      exclusive
      value={value}
      onChange={(e, value) => {
        if (value !== null) onChange(value);
      }}
      {...other}
      sx={{
        border: '1px solid',
        borderColor: 'primary.shade_200',
        borderRadius: '6px',
        width: '100%',
        minWidth: isDesktop ? '400px' : undefined,
        label: {
          fontSize: '18px',
          fontWeight: '400',
          cursor: 'pointer',
        },
        '&&& .Mui-selected': {
          bgcolor: 'purple2.main',
          color: 'white',
          '& label': {
            color: 'white',
            fontWeight: 700,
          },
        },
      }}
    >
      <ToggleButton
        sx={{
          width: '51%',
          borderRadius: '5px',
          border: 'none',
          height: isDesktop ? '48px' : '40px',
        }}
        value={option1.id}
      >
        <Typography sx={{ pointerEvents: 'none' }}>{option1.value}</Typography>
      </ToggleButton>
      <ToggleButton
        sx={{
          width: '51%',
          borderRadius: '5px',
          border: 'none',
          height: isDesktop ? '48px' : '40px',
        }}
        value={option2.id}
      >
        <Typography sx={{ pointerEvents: 'none' }}>{option2.value}</Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
